<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="login">
      <card class="card-login card-plain">
        <div slot="header">
          <div class="logo-container">
            <img :src="logoSrc" alt />
          </div>
        </div>

        <div>
          <div class="text-center login-title">
            <h3>
              <router-link class="link footer-link" to="/register">{{ $t("Login.EAA.Name") }}</router-link>
            </h3>
          </div>
          <p style="color:#BA0000;" v-show="signinError">
            <strong>{{ $t("Login.EAA.Sign_In_Error") }}</strong>
          </p>
          <p style="color:#BA0000;" v-show="signLockError">
            <strong>{{ $t("Login.EAA.Sign_Lock_Error") }}</strong>
          </p>
          <fg-input
            v-model="model.email"
            v-validate="'required|email'"
            name="username"
            :error="getError('email')"
            class="no-border form-control-lg"
            placeholder="Email"
            addon-left-icon="now-ui-icons ui-1_email-85"
          ></fg-input>

          <fg-input
            v-model="model.password"
            v-validate="'required|min:5'"
            type="password"
            name="password"
            :error="getError('password')"
            class="no-border form-control-lg"
            placeholder="Password"
            addon-left-icon="now-ui-icons ui-1_lock-circle-open"
          ></fg-input>
          <p v-show="signLockError" class="nav-align-center" >
            <strong style="color:#BA0000;">請於{{ formattedTime }}後再試</strong>
          </p>
        </div>
        <div slot="footer">
          <div class="d-block text-center mb-2">{{$t("Login.EAA.Version",{ version: `：v${version}`})}}</div>
          <n-button native-type="submit" type="info" round block size="lg">{{ $t("Login.EAA.Login") }}</n-button>

          <!-- <el-button v-on:click="lineLogin" class="btn-block" type="success" block>LINE Login</el-button> -->
          <!-- <a :href="lineLoginUrl" target="_blank">LINE Login</a> -->

          <!-- <div class="pull-left">
            <h6>
              <router-link class="link footer-link" to="/register">
                Create Account
              </router-link>
            </h6>
          </div>

          <div class="pull-right">
            <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6>
          </div>-->

          <br><br>
          <!-- <el-button type="text" class="w-100" @click="goToQcPos">點此前往平板接單機介面</el-button> -->
        </div>
      </card>
    </form>
  </div>
</template>
<script>

export default {
  name: "login",
  data() {
    console.log("query debug", this.$route.query);
    return {
      signinError: false,
      remainingSeconds: 0,
      countdownId: null,
      signLockError: false,
      model: {
        email: "",
        password: ""
      },
      lineLoginUrl: process.env.VUE_APP_APIHOST + "/line/signin"
    };
  },
  computed: {
    version() {
      return process.env.PACKAGE_VERSION;
    },
    logoSrc() {
      // "img/qc_logo.png"
      return process.env.VUE_APP_LOGO;
    },
    formattedTime() {
      const minutes = Math.floor(this.remainingSeconds / 60);
      const seconds = this.remainingSeconds % 60;
      return `${minutes} 分 ${seconds} 秒`;
    }
  },
  methods: {
    // async ssoLogin() {
    //   const params = new URLSearchParams();
    //   params.append('response_type', 'code');
    //   params.append('client_id', 'aa2d3727-7368-547b-874f-bb13551eda89');
    //   params.append('redirect_uri', 'https://app-dev.quickclick.cc/auth/dotdot/callback');
    //   params.append('scope', 'openid');
    //   params.append('type', 'eaa');
    //   //重定向用户到认证服务器
    //   window.location = `https://app-dev.quickclick.cc/auth/dotdot?${params.toString()}`;
    // },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    lineLogin() {
      // 不同domain偵測不到
      window.location =
        process.env.VUE_APP_APIHOST +
        "/line/signin?redirect_to=" +
        window.location.protocol +
        "//" +
        window.location.host +
        "/line-login";
      // let lineAuthWindow = window.open(process.env.VUE_APP_APIHOST + '/line/signin', 'winname', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=600,height=600');
      // lineAuthWindow.onbeforeunload = function(){ console.log(' we are back')}
    },
    async login() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform login call

        // 因為 action 包裝了 Promise 所以可以使用 then 和 catch 來接收非同步回傳狀態
        this.$store
          .dispatch("login", {
            type: "eaa",
            username: this.model.email,
            password: this.model.password
          })
          .then(() => {
            // 接收 resolve
            // console.log('3. get Promise resolve');
            setTimeout(() => {
              // 使用 $router.push 轉跳到 hello Page
              if (
                this.$route.query &&
                this.$route.query.p === "ln" &&
                this.$route.query.s
              ) {
 
                this.$router.push(
                  `/line-notify-groups?shop_id=${this.$route.query.s}&shop_name=${this.$route.query.n}`
                );
              } else {
                this.$router.push("/");
              }
            }, 1000);
          })
          .catch(e => {
            // 接收 reject
            if (e.data.remaining_seconds) {
              this.signinError = false;
              this.signLockError = true;
              this.remainingSeconds = e.data.remaining_seconds;
              this.startCountdown();
            } else {
              this.signinError = true;
            }
          }
        );
      }
    },
    startCountdown(){
       if(this.countdownId != null){
         clearInterval(this.countdownId);
         this.countdownId = null;
       }
       this.countdownId = setInterval(() => {
        this.remainingSeconds--;
      }, 1000);
    },
    // async lineLogin() {
    //   window.location.replace('http://localhost:9898/line/signin')
    // }

    goToQcPos() {
      window.open(`${process.env.BASE_URL}qcpos/login`, '_blank');
    }
  },
  watch: {
    'model.email': function(val){
        if(typeof val == 'string') this.model.email = val.trim();
    },
    remainingSeconds: function(newRemainingSeconds) {
      if (newRemainingSeconds <= 0) {
        clearInterval(this.countdownId);
        this.signLockError = false;
      }
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.lineLoginButton {
  background: url("/img/btn_login_base.png") no-repeat;
  background-size: "inherit";
  /* cursor:pointer; */
  width: 100%;
  height: 100px;
  border: none;
}
</style>
